import wixWindow from 'wix-window';
import { fireBIEvent } from 'public/bi-events.js';
import { getLocation } from 'backend/location';
import { getCountry } from 'backend/wix-atlas';

$w.onReady(function () {

    if (wixWindow.rendering.env === "browser") {
        // getCurrentGeoLocation();
        $w('#box57').onClick(() => {
            const biFields = {
                button_name: 'Get 50% off',
                topic: 'Branded App Users LP',
                url: 'https://www.wix.com/app-builder'
            }
            fireBIEvent(19, 703, biFields);
        })

        $w('#box72').onClick(() => {
            const biFields = {
                button_name: 'Build Your App',
                topic: 'Branded App Users LP',
                url: 'https://www.wix.com/app-builder'
            }
            fireBIEvent(19, 703, biFields);
        })

        $w('#box58').onClick(() => {
            const biFields = {
                button_name: 'Get 50% off',
                topic: 'Branded App Users LP',
                url: 'https://www.wix.com/app-builder'
            }
            fireBIEvent(19, 703, biFields);
        })

        // $w('#box61').onClick(() => {
        //     const biFields = {
        //         button_name: 'Get 50% off',
        //         topic: 'Branded App Users LP',
        //         url: 'https://www.wix.com/app-builder'
        //     }
        //     fireBIEvent(19, 703, biFields);
        // })

        $w('#box60').onClick(() => {
            const biFields = {
                button_name: 'Get 50% off',
                topic: 'Branded App Users LP',
                url: 'https://www.wix.com/app-builder'
            }
            fireBIEvent(19, 703, biFields);
        })

        $w('#button17').onClick(() => {
            const biFields = {
                button_name: 'Watch Video',
                topic: 'Branded App Users LP',
                url: 'https://www.wix.com/app-builder'
            }
            fireBIEvent(19, 703, biFields);

            wixWindow.openLightbox('Video')
        })
    }

});

// const getCurrentGeoLocation = async () => {
//     try {
//         const userGeoLocation = await wixWindow.getCurrentGeolocation();
//         let location = await getLocation(userGeoLocation);
//         const lat = userGeoLocation.coords.latitude;
//         const lon = userGeoLocation.coords.longitude;
//         getCountry(lat, lon);
//         await getPrice(location.address.country_code);
//     } catch (error) {
//         console.error(error);
//     }

// }

// const getPrice = (country_code) => {

//     switch (country_code.toLowerCase()) {
//     case 'ps' || 'il':
//         changePriceDueToCountry('398', 'Price including VAT', '796', 'ILS') //price, vat, discount, currency
//         break;
//     case 'fr':
//         changePriceDueToCountry('96', 'Price including VAT', '192', 'EUR') //price, vat, discount, currency
//         break;
//     case 'de':
//         changePriceDueToCountry('96', 'Price including VAT', '191', 'EUR') //price, vat, discount, currency
//         break;
//     case 'au':
//         changePriceDueToCountry('110', 'Price including GST', '220', 'USD') //price, vat, discount, currency
//         break;
//     default:
//         changePriceDueToCountry('100', 'Price does not include VAT \ GST', '200', 'USD') //price, vat, discount, currency
//     }
// }

// const changePriceDueToCountry = (price, vat, discount, currency) => {
//     $w('#priceTxt').text = price;
//     $w('#vatTxt').text = vat;
//     $w('#currencyTxt').text = currency;
//     $w('#discountTxt').text = discount;
// }